import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux'
import { useHistory } from "react-router-dom";
import {AccessRights} from 'lib/constants/accessRights'
import MainPageComponent from "./main.page";
import LoadingComponent from "components/loading";
import { getLang } from "app/feature/constants";
import {canAccess, hasEmployeeAddAccessRightSelector} from "modules/profile/redux/selector/profile.selector";

function MainPageContainer() {
  const history = useHistory()
  const hasEmployeeViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Employee.READ));
  const hasEmployeeAddAccessRight = useSelector(state =>
    hasEmployeeAddAccessRightSelector(state));
  const lang = useSelector(state => state.constant.languages);
  const isWithinLimit = useSelector(state =>
    (state.session.company.properties && state.session.company.properties.employee_count === null) ||
    (state.employee.employeeList.activeCount && state.employee.employeeList.activeCount < state.session.company.properties.employee_count)
  );

  const [activeIndex, setActiveIndex] = useState(0);
  const tabLabels = [getLang(lang, "label.EMPLOYEE_LIST")];

  useEffect(() => {
    if(!hasEmployeeViewAccessRight){
      history.push('/admin/dashboard')
    }
  }, [history, hasEmployeeViewAccessRight])

  if (!hasEmployeeViewAccessRight) return <LoadingComponent />;

  const handleChange = (event, index) => {
    setActiveIndex(index);
  };

  return (
    <>
      <MainPageComponent
        hasEmployeeAddAccessRight={hasEmployeeAddAccessRight}
        handleChange={handleChange}
        activeIndex={activeIndex}
        tabLabels={tabLabels}
        lang={lang}
        isWithinLimit={isWithinLimit}
      />
    </>
  );
}

export default MainPageContainer;
